import axios from 'axios';
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { getCookie } from 'utils/cookies';

const getFilterPreference = (contextConfiguration) => {
	const token = getCookie('authToken');
	return axios.get(
		'/zoekopdrachten',
		{
			...commonConfiguration,
			...contextConfiguration,
			headers: {
				Authorization: token ? `Token ${token}` : undefined,
				'X-Requested-With': 'XMLHttpRequest',
			}
		}
	).catch(onRequestError);
};

export default getFilterPreference;
